"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
const validation_1 = __importDefault(require("../../../../../../validation"));
const getParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
    snapshotId: validation_1.default.rules.string().required().label('Snapshot ID'),
    fileType: validation_1.default.rules.string().oneOf([
        'policyPdf',
        'googlePrivacyLabelCsv',
    ]).required().label('File Type'),
};
const getParams = {
    rules: getParamRules,
    schema: validation_1.default.schema(getParamRules),
};
exports.get = { params: getParams };
